<div
  *transloco="let transloco"
  [ngClass]="{
    'mb-5': !this.props.disableMargin
  }"
  class="formly-group mt-0 flex flex-col gap-2">
  @if (this.props.header) {
    <div class="formly-header" [ngClass]="this.props.headerClass || 'text-2xl'">
      <span>{{ transloco(this.props.header) }}</span>
    </div>
  }

  @if (this.props.label && !this.props.hideLabel) {
    <label
      [for]="id"
      class="formly-group-title"
      [ngClass]="this.props.labelClass || 'mb-5 text-2xl'">
      <span>{{ transloco(this.props.label) }}</span>
      @if (this.props.required && !this.props.hideRequiredMarker) {
        <span aria-hidden="true" class="text-red-600">*</span>
      }
      @if (this.props.showHorizontalLine || this.props.showHorizontalLine === undefined) {
        <hr class="m-0" />
      }
    </label>
  }
  <ng-container #fieldComponent></ng-container>

  @if (this.showError) {
    <small class="text-red-600">
      <formly-validation-message
        class="ui-message-text"
        [field]="this.field"></formly-validation-message>
    </small>
  }

  @if (this.props.description) {
    <small class="text-gray-500">
      {{ transloco(this.props.description) }}
    </small>
  }

  @if (this.props.footer) {
    <div class="formly-footer" [ngClass]="this.props.footerClass || 'text-2xl'">
      <span>{{ transloco(this.props.footer) }}</span>
    </div>
  }
</div>
